import { safeDefine } from "../../registration/safe-define.js";
import { DialogPopupElement } from "../../ui/dialog/popup.js";
//#region src/define/ui/dialog-popup.ts
safeDefine(DialogPopupElement);
//#endregion

//# sourceMappingURL=dialog-popup.js.map